var layer = {

    init: function() {

        var dataLayerAdd = {};
        var dataLayerQnty = 1;

        $.getJSON('/cart.js', function(cartJson) {
            cart = cartJson;
        });


        $(window).on('dataLayer-add-update-product', function(e, found) {
            var inSale = 'not_in_sale';

            if( found.compare_at_price  > found.price ) {
                inSale = 'in_sale';
            }

            dataLayerAdd = {
                'products': [{
                    'name': found.name, // #16
                    'id': found.id.toString(), // #17
                    'price': (found.price / 100).toFixed(2), // #18
                    'brand': 'dAgency_brand',
                    'category': '', // #19
                    'variant': found.option2, // #22
                    'quantity': dataLayerQnty.toString(), // #38
                    'dimension14': inSale, // #22
                    'dimension15': found.option1 // #39
                }]
            };
        });

        $(window).on('dataLayer-add-update-qnty', function(e, qty){
            dataLayerQnty = qty;

            var newProduct = $.extend(dataLayerAdd.products[0], {'quantity': dataLayerQnty.toString()})
            dataLayerAdd = { 'products': [newProduct] };
        });

        $('[data-dataLayer="product-push"]').on('click', function(e) {

            $.getJSON('/cart.js', function(cart) {

                if( cart.items.length <= 0 ) {

                    dataLayer.push({
                        'gaHitType' : 'event',
                        'event': 'goal_event',
                        'eventCategory': 'cart_created',
                        'eventAction' : dataLayerAdd.products[0].id + "|" + dataLayerAdd.products[0].variant + "|" + dataLayerAdd.products[0].dimension15 + "|" + dataLayerAdd.products[0].dimension14
                    });
                }
            });

            dataLayer.push({
                'event': 'add_to_cart',
                'ecommerce': {
                    'add':  dataLayerAdd
                }
            });

        });


        $('[data-dataLayer="tile-push"]').on('click', function(e){
            var pid = $(this).attr('data-pid');

            $(window).trigger('dataLayer-push-tile-' + pid);

        });

        $('[data-dataLayer="banner-push"]').on('click', function(){
            var cid = $(this).attr('data-bid');

            $(window).trigger('dataLayer-push-banner-' + cid);

        });

        $('[data-dataLayer="menu-push"]').on('click', function(){
            var mid = $(this).attr('data-mid');

            $(window).trigger('dataLayer-push-menu-' + mid);
            //$(this).attr('data-mid',mid).trigger('click');

        });

        $('[data-dataLayer="cartItem-push"]').on('click', function(){
            var pid = $(this).attr('data-pid');

            $(window).trigger('dataLayer-push-cartItem-' + pid);

        });

        $('[data-dataLayer="subscription-push"]').on('click', function(){

            $(window).trigger('dataLayer-push-subscription');

        });
        

    },

};

$(document).ready(function() {

    if ( typeof dataLayer != 'undefined' ) {
        layer.init();
    }
});



$('[data-id="78354"]').on('submit', function(){
    if(!$(this).attr('validated'))
    {
    // GET THE VARS
        var email = $('#email').val();


        $.ajax({ 
            type: 'GET', 
            dataType: 'json',
            url: 'url.php',
            beforeSend : function(){   },
            success: function(answer){   
            if(answer.error === false){
                    dataLayer.push({
                    'event':'GAevent',
                    'eventID':'29',
                    'eventCategory':'corporate_gifts',
                    'eventAction':'submit',
                    'eventLabel':'send_request'
                    });
            } 
            if(answer.error === true){
                //display the errors
            }
        }
    });
    return false;  
    }                            
   return true;
});